import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core'
import { CompanyHeaderComponent } from 'app/securities-level/company-header/company-header.component'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../environments/environment'
import { TradingHeaderComponent } from '../trading-header/trading-header.component'
import { TradingCompareToPeerComponent } from '../trading-compare-to-peer/trading-compare-to-peer.component'
import { AuthorizeService } from '../../service/authorize.service'
import { PricePerformanceComponent } from '../price-performance/price-performance.component';
@Component({
  selector: 'app-trading',
  templateUrl: './trading.component.html',
  styleUrls: ['./trading.component.scss']
})
export class TradingComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('companyHeaderComponent')
  companyHeaderComponent: CompanyHeaderComponent
  @ViewChild('tradingHeaderComponent')
  tradingHeaderComponent: TradingHeaderComponent
  @ViewChild('tradingCompareToPeerComponent')
  tradingCompareToPeerComponent: TradingCompareToPeerComponent
  @ViewChild('PricePerformanceComponent')
  pricePerformanceComponent: PricePerformanceComponent
  subscription: Subscription
  print = false
  pdf = false
  displayHeader = true
  period
  tradingCompareRadio
  pricePerType = 0
  symbol
  printFirst = true
  printPage = false
  displayComponent = false
  paramValue
  getPrint
  printTrading
  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print

    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf)
    print === undefined ? (this.print = false) : (this.print = print)

    if (symbol) {
      this.cpmService.getSecurityProfileNew(symbol)
    }

    this.store.getSecurityProfileNewResultObservable().subscribe(
      response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        this.displayComponent = true
        if (this.symbol === null) {
          this.displayComponent = false
        }
      },
      err => {
        this.displayComponent = false
      }
    )

    this.store.getPeriodInputObservable().subscribe(period => {
      this.period = period
    })

    if (this.print || this.pdf) {
      this.displayHeader = true
      this.printPage = true
      this.printTrading = true
    } else {
      this.displayHeader = false
      this.printPage = false
      this.printTrading = false
    }

    this.changeValue('YTD')
  }
  get isUserHasPermission(): Boolean {
    return this.authorization.hasRole('ROLE_USER')
  }

  ngOnDestroy() { }

  changeValue(data) {
    this.store.setPeriodInputBehavior(data)
  }

  tradingToPeer(data) {
    this.tradingCompareRadio = data
  }
  priceType(data) {
    this.pricePerType = data
  }

  exportPrint = function (symbol, period, type, pricePer) {
    return function tradingPrint() {
      const endcodeSymbol = encodeURIComponent(symbol)
      const popupWin = window.open(
        `/#/trading/${endcodeSymbol}/${period}/${type}/${pricePer}`,
        '_blank',
        'width=850px,height=1024px'
      )
    }
  }

  exportPdf = function (symbol, period, type, pricePer) {
    const service = this.cpmService
    return function tradingPdf() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.downloadFile(
        `${
        environment.cpmBaseUrl
        }/pdf/trading?symbol=${endcodeSymbol}&period=${period}&type=${type}&pricePerType=${pricePer}`
      )
    }
  }

  popupPrint() {
    if (this.printFirst) {
      this.printFirst = false
      window.print()
    } else {
      this.printFirst = false
    }
  }

  exportEmail = function (symbol, period, type, service) {
    return function mailTrading() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.saveTradingPdfFile(endcodeSymbol, period, type).then(filename => {
        const subject = 'Trading'
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        )
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`
      })
    }
  }

  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set(
      'email',
      this.exportEmail(
        this.symbol,
        this.period,
        this.tradingCompareRadio,
        this.cpmService
      )
    )
    arrayOfFunctions.set(
      'print',
      this.exportPrint(this.symbol, this.period, this.tradingCompareRadio, this.pricePerType)
    )
    arrayOfFunctions.set(
      'pdf',
      this.exportPdf(this.symbol, this.period, this.tradingCompareRadio, this.pricePerType)
    )
    return arrayOfFunctions
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 5000);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading/trading.component.ts